// Import gesture handler conditionally - polyfill handles web
import 'react-native-gesture-handler';
import React from 'react';
import { StatusBar } from 'expo-status-bar';
import { View, Text, StyleSheet } from 'react-native';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { AppNavigator } from './src/navigation/AppNavigator';
import { validateEnv } from './src/config/env';

export default function App() {
  // Validate environment variables on startup
  const envValidation = validateEnv();

  // Show error screen if environment is invalid
  if (!envValidation.valid) {
    return (
      <View style={styles.errorContainer}>
        <StatusBar style="light" />
        <Text style={styles.errorTitle}>Configuration Error</Text>
        <Text style={styles.errorMessage}>Missing required environment variables:</Text>
        {envValidation.missing.map(key => (
          <Text key={key} style={styles.errorItem}>
            - {key}
          </Text>
        ))}
        <Text style={styles.errorHint}>
          Please rebuild the app with proper environment configuration.
        </Text>
      </View>
    );
  }

  return (
    <SafeAreaProvider>
      <StatusBar style="light" />
      <AppNavigator />
    </SafeAreaProvider>
  );
}

const styles = StyleSheet.create({
  errorContainer: {
    flex: 1,
    backgroundColor: '#0a0e1a',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  errorTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#ff4444',
    marginBottom: 16,
  },
  errorMessage: {
    fontSize: 16,
    color: '#ffffff',
    marginBottom: 12,
    textAlign: 'center',
  },
  errorItem: {
    fontSize: 14,
    color: '#00D9FF',
    marginVertical: 4,
  },
  errorHint: {
    fontSize: 14,
    color: '#888888',
    marginTop: 20,
    textAlign: 'center',
  },
});
